module.exports = __webpack_public_path__ + "img/avatar.00a1b61d.png";